import React      from 'react';
import PropTypes  from 'prop-types';

import ActorProfileRecommendations       from '../ActorProfileRecommendations';
import AlbumDescription                  from './AlbumDescription';
import Gallery                           from '../../Gallery/Gallery';
import GuestAccess                       from '../../../utils/GuestAccess';
import LogoLoader                        from '../../Loader/LogoLoader';
import ProfileFeedback                   from '../../ProfileFeedback/ProfileFeedback';
import TagSuggest   					 from '../../TagSuggestion/TagSuggest';
import VideoRecommendationsSimilarVideos from '../../VideoRecommendations/VideoRecommendationsSimilarVideos';
import VideoRecommendationsGridByActor   from '../../VideoRecommendations/VideoRecommendationsGridByActor';

import Flux         from '../../../flux/Flux';
import UrlBuilder   from '../../../utils/UrlBuilder';
import ReloadHelper from '../../../utils/ReloadHelper';
import Translations from '../../../utils/Translations';
import withRouter 	from '../../HigherOrderComponents/Utility/withRouter';
import { Navigate } from 'react-router';
class ActorProfileVideoDetail extends React.PureComponent {
    constructor(props) {
		super(props);

		const albumId   = this.getAlbumIdFromUrl();

        this.state = {
			albumId,
			albumData: {},
            ready:     false,
        };

		this.onGalleryChange       = this.onGalleryChange.bind(this);
		this.getAlbumData          = this.getAlbumData.bind(this);
		this.onCinematicModeChange = this.onCinematicModeChange.bind(this);
		this.getAlbumIdFromUrl	   = this.getAlbumIdFromUrl.bind(this);
		this.handleOnTagClick	   = this.handleOnTagClick.bind(this);

		this.profileVideoDetailsRef = null;
    }

    componentDidMount() {

		this.setState({albumData: this.getAlbumData(this.props.actorData, this.state.albumId)});

		Flux.Gallery.addGalleryChangeListener(this.onGalleryChange);
		Flux.Gallery.addCurrentVideoCinematicModeListener(this.onCinematicModeChange);

		Flux.Gallery.loadGallery(this.state.albumId);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			const albumId = this.getAlbumIdFromUrl();

			this.setState({albumId});
			Flux.Gallery.loadGallery(albumId);
		}
	}

    componentWillUnmount() {
		Flux.Gallery.removeGalleryChangeListener(this.onGalleryChange);
		Flux.Gallery.removeCurrentVideoCinematicModeListener(this.onCinematicModeChange);
	}

	getAlbumIdFromUrl() {
		const videoId = this.props.params.videoId;
		const id 	  = videoId.split('-')[0];
		return parseInt(id);
	}

	onCinematicModeChange() {
		if (this.profileVideoDetailsRef) {
			if (Flux.Gallery.isCinematicModeEnabled()) {
				this.profileVideoDetailsRef.classList.add('-cinematic-mode');
			} else {
				this.profileVideoDetailsRef.classList.remove('-cinematic-mode');
			}
		}
	}

    onGalleryChange(actorId, albumId) {
		let albumData = null;
		if (albumId === this.state.albumId) {
			albumData = this.getAlbumData(null, null, true);
		}
		const state = {
			albumData:       albumData,
			actorData:       albumData?.actor,
			isAlbumBought:   albumData?.isBought,
			isAlbumLiked:    albumData?.isLiked,
			isAlbumFavorite: albumData?.isFavoriteAlbum,
			ready:           true,
		};

		if (!this.state.ready) {
			state.isAlbumBoughtInitial = albumData?.isBought;
		}
		this.props.setVideoRouteInfo({
			id:      albumId,
			path:    this.props.location?.pathname || window.location.pathname,
			classic: albumData?.isClassic,
		});
		this.setState(state);
	}

	getAlbumData(actorData, albumId, ignoreCheck) {

		actorData   = actorData || (this.props.actorData);
		albumId     = albumId || this.state.albumId;
		ignoreCheck = ignoreCheck || false;

		let albumData = null;

		if (albumId) {
			albumData = Flux.Gallery.getGalleryData(albumId);
		}

		if (!albumData || (!ignoreCheck && !albumData.video)) {
			albumData = null;
		}

		return albumData;
	}

	onVip30Click(e) {
		ReloadHelper.reload(UrlBuilder.buildVIP30Url(), e);
	}

	onCampaignClick(e) {
		ReloadHelper.reload(UrlBuilder.buildContestDetailRoute(this.state.albumData.campaignId), e);
	}

    onBuy() {
        Flux.Search.clearVideoCache();
    }

	getVideo() {
		const album = this.state.albumData;
		const actor = this.props.actorData;

		const accessSettings   = {
			needAvs:   album.needAvs,
			needVip:   album.needVip,
			needLogin: true,
		};

		if (album.ignorePaymentFirst) {
			accessSettings.ignorePaymentFirst = true;
		}

		const onShowModal       = function() {
			GuestAccess.onContentAccess(accessSettings);
		};
		const useOnClickHandler = !Flux.Guest.isLoggedIn() || album.needVip || album.needAvs;

		return <div className="profile-video-details--panel profile-video-details--video -content">
		<div className="context-box--motive">
			<div className="box--fixed-ratio -ratio16_9">
				{ album.contestPlace > 0 && album.contestPlace < 4 && <span className={`contents__placing -show-on-hover icon-actor -icon-award-user-ranking-${album.contestPlace}`}></span> }
				<div className="box--fixed-ratio__content gallery__frame has-dark-poster">
					<div className="h-height-full">
						<Gallery actorId={actor.id}
								initialVideos={[album.video]}
								isModelGuestFavorite={album.isModelGuestFavorite}
								videoBadgesConfig={{}}
								onShowModal={useOnClickHandler ? onShowModal : null}
								showDownload={actor.id !== 5613624 && album.isDownloadPermitted} //id 5613624 disable download only for Lucy-cat
								isHD={album.isHD}
								showCinematicMode={true}
								vxbuttonAdditionalStyle={{height: "55px", lineHeight: "55px"}}
                                triggerPauseVideoEvent={true}
                                onBuy={this.onBuy}
						/>
					</div>
				</div>
			</div>
		</div>

		<div className="profile-video-details--description">
			<div className="profile-video-details--description-row">
				<h1 className="profile-video-details--description-row-title">
					{album.title}
				</h1>
			</div>

			{album.isContestContent && !album.gift && <div className="profile-video-details--description-contest0">
				<a href={UrlBuilder.buildContestDetailRoute(album.campaignId)} onClick={this.onCampaignClick}>
					<span className="profile-video-details--description-contest0-link">{Translations.get('Contest')}: {album.contestTitle} </span>
				</a>
			</div>}

			<div className="profile-video-details--description-info">
				<AlbumDescription album={album.video} actor={album.actor}/>
			</div>

			<div className="profile-video-details--description-tags">
				<div className="profile-video-details--description-tags-list">
						{album.isVip30 && <span className="profile-video-details--description-tags-list-item profile-video-details--description-tags-list-item--gold">
							<a className="js-pjax-link profile-video-details--description-tags-list-item-tag profile-video-details--description-tags-list-item-tag--gold"
							   href={UrlBuilder.buildVIP30Url()}
							   onClick={this.onVip30Click}
							   dangerouslySetInnerHTML={{__html: Translations.get('VIP30TAG')}} />
						</span>}

						{ album.displayTags.length > 0 && album.displayTags.map(tag =>
							<div
								key		    = {tag}
								onMouseDown = {(e) => this.handleOnTagClick(tag, e)}
								className   = "profile-video-details--description-tags-list-item"
							>
								<span className="profile-video-details--description-tags-list-item-tag" >{tag}</span>
							</div>
						)}
				</div>
				{album.isBought && !album.needBuying &&	<div>
					<div className="actor-pictures__tag__text--footer" style={{fontSize: "14px", padding: "20px 0 10px 0"}} onClick={() => this.setState({showVideoTagsComponent: !this.state.showVideoTagsComponent})}>
                        <span className="h-cursor-pointer">{Translations.get('addTag')}</span>
						<img className="actor-pictures__tag__text--footer--icon h-cursor-pointer" src="/assets/img/plus-full.svg" style={{marginLeft: "10px"}}/>
                    </div>
					<div className="profile-video-details--description-tags-suggest">
                        {this.state.showVideoTagsComponent && <TagSuggest albumId={this.state.albumData.id}/>}
                    </div>
				</div>}
			</div>
		</div>
	</div>;
	}

	getComments() {
		return <div className="row profile-video-details--comments" id="pjax-scrollto-comments">
			<div className="container-block--actor-grid -margin-bottom-lg -margin-top-sm comments-with-top-red-border profile-video-details--red-top-border">
				<div className="col-xs-12">
					<div className="container-block--actor-profile-feedbacks js-container-feedbacks">
						<ProfileFeedback albumId={this.state.albumData.id} editable={this.state.albumData.allowCommentAlbum} userPictureUrl={this.state.albumData.userPictureUrl}/>
					</div>
				</div>
			</div>
		</div>;
	}

	getSimilarVideos() {
		return <div className="profile-video-details--panel profile-video-details--similar-videos -right-side-bar">
			<div id="same-actor-video-recommendations-container-column" className="profile-video-details--similar-videos-wrapper">
				<VideoRecommendationsSimilarVideos albumId			     = {this.state.albumData.id}
												   actorId			  	 = {this.props.actorData.id}
												   actorName		  	 = {this.props.actorData.name}
												   navigateTo 		  	 = {this.props.navigateTo}
												   orientationIsVertical = {true}
				/>
			</div>
		</div>;
	}

	getVideoRecommendations() {
		return <section className="container-block--actor-grid -margin-bottom-lg -margin-top-sm profile-video-details--red-top-border">
			<div className="media-panel container-block -margin-bottom-lg">
				<div className="context-box--actor-profile clearfix">
					<h2 className="context-box__title h-left" dangerouslySetInnerHTML={{__html: Translations.get('MediaPanelVideoAlbumRecommendations')}} />
				</div>
				<div id="video-recommendations-container">
					<VideoRecommendationsGridByActor
						actorId={this.props.actorData.id}
						sameActor={false}
						actorName={this.props.actorData.name}
						lazyImageLoading={true}
					/>
				</div>
			</div>
		</section>;
	}

	handleOnTagClick(tag, e) {
		const url = UrlBuilder.buildActorProfileVideosUrl(this.props.actorData.name) + "?tag=" + tag;
		this.props.navigateTo(url, e);
	}

    render() {
        if (!this.state.ready) {
			return <LogoLoader pulse={true} isRelative/>;
        }

        return (this.state.albumData
			? <div>
				<section className="profile-video-details" ref={ref => this.profileVideoDetailsRef = ref}>
					{this.getVideo()}
					{Flux.Guest.isLoggedIn() && this.getComments()}
					{this.getSimilarVideos()}
				</section>
				{this.getVideoRecommendations()}
				<ActorProfileRecommendations actorId={this.props.actorData.id} />
            </div>
			: <Navigate to={UrlBuilder.buildActorProfileVideosUrl(this.props.actorData.name)} />
        );
    }
}

ActorProfileVideoDetail.propTypes = {
	actorData: 		   PropTypes.object.isRequired,
    albumId: 		   PropTypes.number,
	location: 		   PropTypes.object.isRequired,
	navigateTo: 	   PropTypes.func.isRequired,
	params: 		   PropTypes.object.isRequired,
	setVideoRouteInfo: PropTypes.func.isRequired,
};

export default withRouter(ActorProfileVideoDetail);
